/**
 * Logo Home component.
 * @module components/UnibaTheme/Logo/LogoSlimHome
 */
import { Image } from 'semantic-ui-react';
import LogoImage from './LogoHome.svg';

/**
 * Logo component class.
 * @function LogoSlimHome
 * @param {Object} intl Intl object
 * @returns {string} Markup of the component.
 */
const LogoSlimHome = ({
  alt,
  ...attributes
}) => {
  return (
      <Image
        src={
          LogoImage
        }
        height="24"
        width="20"
        alt={alt}
        title={alt}
        {...attributes}
      />
  );
};

export default LogoSlimHome;